import { useGameStore } from "./store/gameStore.js";
import { StartScreen } from "./screens/StartScreen.js";
import { PlayScreen } from "./screens/PlayScreen.js";
import { HistoryScreen } from "./screens/HistoryScreen.js";
import { SidePanel } from "./components/SidePanel.js";

export function App() {
  const screen = useGameStore((s) => s.screen);

  return (
    // `.desktop-stage` only changes anything at >=900px (see styles.css) --
    // below that it's a plain full-height wrapper and `.side-panel` stays
    // display: none, so mobile layout is pixel-for-pixel unchanged
    // (2026-07-17 フィードバック #5).
    <div className="desktop-stage">
      <div className="app-shell">
        {screen === "start" && <StartScreen />}
        {screen === "play" && <PlayScreen />}
        {screen === "history" && <HistoryScreen />}
      </div>
      <SidePanel />
    </div>
  );
}
